import { useContext, useEffect, useState } from 'react';
import { ContextApi } from '../../context/contextApi';
import { DetailsCamera } from '../detailsCamera/detailsContainer';

import styles from './style.module.scss'

export function CardCamera({ responseCameras }) {
    const [showDetailCamera, setShowDetailCamera] = useState(false)

    return (
        <div className={styles.containerCardCamera}>
            <div className={styles.headerCard}>
                <div>
                    <span className={styles.titleHeaderCard}>Nome</span>
                    <p className={styles.descriptionHeaderCard}>{responseCameras.nome_camera}</p>
                </div>
                <div>
                    <span className={styles.titleHeaderCard}>Localidade</span>
                    <p className={styles.descriptionHeaderCard}>{responseCameras.area_regiao.nome}</p>
                    <p className={styles.textLocalit}>{responseCameras.cidade + ' - ' + responseCameras.estado}</p>
                </div>
            </div>
            <div>
                <span className={styles.titleHeaderCard}>Link Parceiro</span>
                <br />
                <a href={responseCameras.parceiro_link} target='_blank' className={styles.descriptionHeaderLink}>{responseCameras.parceiro_link && responseCameras.parceiro_link.length >= 54 ? responseCameras.parceiro_link.slice(' ', 55) + '...' : responseCameras.parceiro_link}{!responseCameras.parceiro_link && ''}</a>
            </div>
            <div 
            className={styles.BTNDetalhes}
            onClick={() => setShowDetailCamera(true)}
            >
                <span>Ver Detalhes</span>
            </div>
            <DetailsCamera 
            setShowDetailCamera={setShowDetailCamera}
            showDetailCamera={showDetailCamera}
            dataCameras={responseCameras}
            />
        </div>
    )
}